import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { XCircle, Phone } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { Button } from "@/components/ui/button";
import { CONTACT } from "@/data/content";

const PaymentCancel = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="payment-cancel-page" className="bg-sand min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 grid place-items-center px-5 pt-40 pb-24">
        <div className="max-w-lg text-center">
          <div className="mx-auto grid place-items-center w-20 h-20 rounded-full bg-sand2 text-ink2">
            <XCircle className="w-10 h-10" />
          </div>
          <h1 className="mt-6 font-serif text-4xl text-forest">Donation cancelled</h1>
          <p className="mt-3 text-ink2">No charge was made. Whenever you’re ready, your support means the world to us.</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Button onClick={() => navigate("/donate")} className="rounded-full bg-terracotta hover:bg-[#b45a3d] text-white px-7 h-12">Return to donate</Button>
            <a href={CONTACT.phoneHref} className="rounded-full border border-forest text-forest px-7 h-12 flex items-center justify-center gap-2 font-semibold">
              <Phone className="w-4 h-4" /> {CONTACT.phone}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PaymentCancel;
